import { Component, Input, OnInit } from '@angular/core';
import { CoreApiService } from '../../../../core/service/core-api-service';
import { AppService } from '../../../../core/service/app.service';
import { JsonRequest } from '../../../../model/jsonRequest.model';
import { properties } from '../../../../../environments/properties';
import { VehicleModel } from '../../../../model/vehicle.model';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { DataViewModule } from 'primeng/dataview';
import { TabViewModule } from 'primeng/tabview';
import { DocumentVehicleModel } from '../../../../model/document.vehicle.model';
import { ImageModule } from 'primeng/image';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { FileUploadModule } from 'primeng/fileupload';
import { TableModule } from 'primeng/table';
import { FormsModule } from '@angular/forms';
import { DriverModel } from '../../../../model/driver.model';
import { compressImage } from '../../../../shared/utils/image-compression.util';
import { isAllowedUploadType } from '../../../../shared/utils/file-type-validator.util';

@Component({
  selector: 'app-detail-vehicle',
  standalone: true,
  imports: [
    TabViewModule,
    DataViewModule,
    ButtonModule,
    CommonModule,
    ImageModule,
    DropdownModule,
    DialogModule,
    FileUploadModule,
    TableModule,
    FormsModule,
  ],
  templateUrl: './detail-vehicle.component.html',
  styleUrl: './detail-vehicle.component.css',
})
export class DetailVehicleComponent implements OnInit {
  @Input('idvehicle') idvehicle!: number;
  vehicleInfo!: VehicleModel;
  newFile: boolean = false;
  ltsDocument: DocumentVehicleModel[] = [];
  ltsTypeDocument: any[] = [];
  selectedTypeDocument: any | undefined;
  selectedDriver: DriverModel | undefined;
  changeDriver: boolean = false;
  lstDriver!: DriverModel[];

  constructor(
    private readonly apiService: CoreApiService,
    private readonly util: AppService,
  ) {}

  ngOnInit(): void {
    this.getVehicle();
    this.getLtsTypeDocument();
  }

  getVehicle(): void {
    const body: JsonRequest = {
      data: JSON.stringify({
        veh_id: this.idvehicle,
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceGetVehicle,
      body,
      (data) => {
        this.vehicleInfo = data.data;
      },
    );
  }

  downloadFile(url: string, fileName: string) {
    this.apiService.downloadFile(url).subscribe((blob) => {
      const link = document.createElement('a');
      const url = window.URL.createObjectURL(blob);
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    });
  }

  getLtsTypeDocument(): void {
    const body: JsonRequest = {
      data: JSON.stringify({
        typ_type_document: 2,
      }),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceGetAllTypeDocument,
      body,
      (data) => {
        this.ltsTypeDocument = data.data;
        this.selectedTypeDocument = this.ltsTypeDocument[0];
      },
    );
  }

  deleteFile(document: any) {
    this.util
      .mostrarConfirmacion('Está seguro que desea borrar el registro?', 1)
      .then((accept) => {
        const body: JsonRequest = {
          data: JSON.stringify([
            {
              veh_doc_veh_id: document.veh_doc_veh_id,
              veh_doc_doc_id: document.veh_doc_doc_id,
              veh_doc_company: this.util.returnEmpresa(),
            },
          ]),
          company: this.util.returnEmpresa(),
          fecha: new Date(),
        };
        this.apiService.consumirWSPost(
          properties.serviceDeleteFileVehicle,
          body,
          (data) => {
            if (data.estado === properties.codeOK) {
              this.util.mostrarToast(
                'Eliminación',
                'Se ha eliminado el documento',
                2,
              );
              this.getVehicle();
            } else {
              this.util.mostrarToast('Eliminación', 'Error al Eliminar', 4);
            }
          },
        );
      });
  }

  dialogNewFile() {
    this.newFile = true;
  }

  async onUploadAuto(files: File[], fileUpload: any) {
    if (!isAllowedUploadType(files[0], true)) {
      this.util.mostrarToast(
        'Detalle Vehículo',
        'Formato no permitido. Solo se aceptan imágenes PNG o JPG o documentos PDF.',
        4,
      );
      fileUpload.clear();
      return;
    }
    this.ltsDocument = [];
    const doc = await compressImage(files[0]);
    const filestring = await this.previewFile(doc);
    this.ltsDocument.push({
      veh_doc_veh_id: 0,
      veh_doc_doc_id: 0,
      veh_doc_company: this.util.returnEmpresa(),
      veh_doc_typ_id: this.selectedTypeDocument.typ_id,
      file: doc,
      filstring: filestring,
      typeDocument: this.selectedTypeDocument,
    });
    fileUpload.clear();
  }

  previewFile(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.result) {
          resolve(reader.result as string);
        } else {
          reject('Error al leer el archivo');
        }
      };
      reader.onerror = () => {};
    });
  }

  removeFile(index: number) {
    this.ltsDocument.splice(index, 1);
  }
  saveFile() {
    const formData = new FormData();
    this.ltsDocument.forEach((doc, index) => {
      formData.append(
        `lista[${index}][veh_doc_veh_id]`,
        this.vehicleInfo.veh_id.toString(),
      );
      formData.append(
        `lista[${index}][veh_doc_company]`,
        this.util.returnEmpresa().toString(),
      );
      formData.append(
        `lista[${index}][veh_doc_typ_id]`,
        doc.veh_doc_typ_id.toString(),
      );
      formData.append(`lista[${index}].file`, doc.file, doc.file.name);
    });
    this.apiService.consumirWSFilePost(
      properties.serviceFilesVehicle,
      formData,
      (resp) => {
        if (resp.estado === properties.codeOK) {
          this.util.mostrarToast('Crear Archivo', 'Se ha creado el Archivo', 1);
          this.closeNewFile();
          this.getVehicle();
        } else {
          this.util.mostrarToast('Crear Archivo', 'Error al crear', 4);
        }
      },
    );
  }

  closeNewFile() {
    this.ltsDocument = [];
    this.newFile = false;
  }

  changeDriverVehicle() {
    this.changeDriver = true;
    this.getLstDriver();
  }

  closeChangeDriver() {
    this.changeDriver = false;
  }

  saveChangeDriver() {
    if (!this.selectedDriver) {
      this.util.mostrarToast(
        'Cambio de Conductor',
        'Debe seleccionar un conductor',
        4,
      );
      return;
    }

    this.vehicleInfo.veh_dri_id = this.selectedDriver.dri_id;
    const body: JsonRequest = {
      data: JSON.stringify(this.vehicleInfo),
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceVehicleChangeDriver,
      body,
      (resp) => {
        if (resp.estado === properties.codeOK) {
          this.util.mostrarToast(
            'Cambio de Conductor',
            'Se ha cambiado de conductor',
            1,
          );
          this.closeChangeDriver();
          this.getVehicle();
        } else {
          this.util.mostrarToast('Cambio de Conductor', 'Error al cambiar', 4);
        }
      },
    );
  }

  getLstDriver(): void {
    const body: JsonRequest = {
      data: '',
      company: this.util.returnEmpresa(),
      fecha: new Date(),
    };
    this.apiService.consumirWSPost(
      properties.serviceGetDriverSinAsignar,
      body,
      (data) => {
        this.lstDriver = data.data;
      },
    );
  }
}
